<div class="bg-light-surface dark:bg-dark-surface rounded-xl flex flex-col gap-3 !p-6 overflow-hidden">
  <!-- Header -->
  <div class="flex items-center gap-2">
    <div class="flex-shrink-0">
      <lucide-angular
        [img]="AlertCircle"
        class="w-5 h-5 text-light-primary dark:text-dark-primary">
      </lucide-angular>
    </div>
    <h1 class="!mb-0">
      Confirmar publicación
    </h1>
  </div>
  <p class="text-light-text-secondary dark:text-dark-text-secondary">
    {{ getMessage() }}
  </p>

  <!-- Article identifiers list -->
  @if (hasIdentifiers()) {
    <div
      class="bg-light-surface-hover dark:bg-dark-surface-hover rounded-lg p-4 border border-light-border dark:border-dark-border"
      [class.max-h-40]="shouldShowScrollableList()"
      [class.overflow-y-auto]="shouldShowScrollableList()">
      <h3 class="!mb-1">Artículos a publicar:</h3>
      <ul class="space-y-1 text-sm text-light-text-secondary dark:text-dark-text-secondary">
        @for (identifier of data.articleIdentifiers; track identifier) {
          <li class="flex items-center gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-light-primary dark:bg-dark-primary flex-shrink-0"></span>
            <span>{{ identifier }}</span>
          </li>
        }
      </ul>
    </div>
  }

  <!-- Warning message -->
  <div class="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4">
    <p class="text-sm text-orange-800 dark:text-orange-200">
      {{ getWarningMessage() }}
    </p>
  </div>

  <!-- Actions -->
  <div class="flex items-center justify-end gap-3 mt-5 items-center">
    <button
      (click)="onCancel()"
      class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
      Cancelar
    </button>
    <button
      (click)="onConfirm()"
      class="flex gap-2 items-center font-medium !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl h-10 !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed duration-200">
      <lucide-angular [img]="Upload" class="w-5 h-5"></lucide-angular>
      Publicar
    </button>
  </div>
</div>